import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { Stake } from '@/components/atoms/assets/Stake'
import { Button } from '@/components/atoms/Button'

import { Routes } from '@/router/routes'

type StakeButton = {
  className?: string
  stakeMore?: boolean
}

export const StakeButton: FC<StakeButton> = ({ className = '', stakeMore }) => {
  const { t } = useTranslation('common')
  const history = useHistory()

  return (
    <Button
      className={className}
      type="primary"
      onClick={() => history.push(Routes.STAKE)}
    >
      <Stake className="-ml-1 h-6" />
      <span className="text-xxs xs:text-xs">
        {!stakeMore ? t('wallet.stake.stake') : t('wallet.stake.stakeMore')}
      </span>
    </Button>
  )
}
